import React from 'react';
import { NavLink } from 'react-router-dom';
import './SideNav.css';
// import './SideNavRtl.css';

const ReportsNav = ({ language }) => {
    return (
        <React.Fragment>
            <ul>
                <li>
                    <NavLink to="/referral" activeClassName="activeTabNav">
                        <span className="imgLink">
                            <img src="/images/darkblue24icons/referral-account-24.png" alt="dashboard" className='invertPrimary' />
                        </span>
                        <span className="txtLink">{language.instavc_my_referral_account}</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/reports/myreferral" activeClassName="activeTabNav">
                        <span className="imgLink">
                            <img src="/images/darkblue24icons/referral-24.png" alt="myprofile" className='invertPrimary' />
                        </span>
                        <span className="txtLink">{language.instavc_myreferral}</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/reports/mysales" activeClassName="activeTabNav">
                        <span className="imgLink">
                            <img src="/images/darkblue24icons/sales-24.png" alt="settings" />
                        </span>
                        <span className="txtLink invertPrimary">{language.instavc_mysales}</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/reports/myearnings" activeClassName="activeTabNav">
                        <span className="imgLink">
                            <img src="/images/darkblue24icons/earnings-24.png" alt="settings" />
                        </span>
                        <span className="txtLink invertPrimary">{language.instavc_myearnings}</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/reports/requestwithdraw" activeClassName="activeTabNav">
                        <span className="imgLink">
                            <img src="/images/darkblue24icons/withdraw-24.png" alt="settings" />
                        </span>
                        <span className="txtLink invertPrimary">{language.instavc_req_withdraw}</span>
                    </NavLink>
                </li>
                {/* Uncomment if needed */}
                {/* <li>
                    <NavLink to="#" activeClassName="activeTabNav">
                        <span className="imgLink">
                            <img src="/images/darkblue24icons/db-setting-24.png" alt="settings" />
                        </span>
                        <span className="txtLink">Settings</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/admin/coupons" activeClassName="activeTabNav">
                        <span className="imgLink">
                            <img src="/images/darkblue24icons/coupon-24.png" alt="settings" />
                        </span>
                        <span className="txtLink">Coupons/Offers</span>
                    </NavLink>
                </li> */}
            </ul>
        </React.Fragment>
    );
}

export default ReportsNav;